// ComponentId — the closed enum of components a course can enable.
//
// Decision (Session 19A): hard-coded enum, NOT a registry-by-string.
// - User selects from this list in form step 3
// - AI ingest uses this to know what to generate
// - Engine uses this to know what to mount
// - Adding a new component = code change in shared (schema) + ingest (prompt) + engine (component impl)
//   That's correct rigidity — components are not user-extensible.
import { z } from 'zod';
export const ComponentIdSchema = z.enum([
    'dashboard', // always-on; no AI generation
    'flashcards', // SRS drilling
    'quiz_mcq', // multiple choice
    'quiz_tf', // true/false
    'glossary', // term definitions
    'essay', // essay drill (prompt + scaffold + model answer)
    'mindmap', // framework tree
    'lecture_notes', // AI summary per case
    'mock_exam', // composite, draws from quiz_mcq + quiz_tf
    'wrong_answers', // runtime-tracked, no AI generation
    'guide', // AI-generated study plan
    'proof_drill', // step-by-step derivation prompts (STEM, Session 19D)
    'free_response', // short_answer / calculation / translation (Session 19AN)
    'reading_passage', // English reading: passage + linked questions (Session 19AN)
]);
export const ALL_COMPONENT_IDS = ComponentIdSchema.options;
//# sourceMappingURL=component-id.js.map